import { Compass } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { GUIDE_TOURS } from '../content';
import { useGuide } from '../engine/useGuide';
import { resolveTourForRoute } from '../utils/resolveTour';

/**
 * Replays the current screen's tour on demand, even with automatic tours off.
 * Lives in the Header and not in the Sidebar: the Sidebar already has an
 * "Ayuda" item pointing at getmatchapp.com/ayuda, and two items with the same
 * name doing different things would be worse than none.
 */
export function GuideLauncher() {
  const { pathname } = useLocation();
  const { start } = useGuide();

  const tourId = resolveTourForRoute(pathname);
  if (!tourId || !GUIDE_TOURS[tourId]) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => start(tourId)}
      aria-label="Guía de esta pantalla"
      className="hidden text-gray-600 hover:text-gray-900 sm:inline-flex"
    >
      <Compass className="mr-2 h-4 w-4" />
      Guía
    </Button>
  );
}
